import 'angular:locale/data:it-CH';
import 'angular:locale/data:fr-CH';
import 'angular:locale/data:en-CH';
import 'angular:locale/data:de-CH';
import './src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
